import React, { useState, useEffect } from "react";
import SideBar from "../../../components/sidebar";
import Header from "../../../components/header";
import "../../../assets/CSS/dashboard.css";
import "../../../assets/CSS/forms.css";
import API_BASE_URL from "../../../config";
import DateReportTable from "./date-range-report";

function DateRangeReport() {
  const [report, setReport] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [loader, setLoader] = useState(false);
  const [query, setQuery] = useState({
    startDate: "",
    endDate: "",
    letterType: "",
    subject: "",
  });
  const [subjectQuery, setSubjectQuery] = useState("");
  const [subjectOptions, setSubjectOptions] = useState([]);

  useEffect(() => {
    if (!subjectQuery) {
      setSubjectOptions([]);
      return;
    }

    const delayDebounce = setTimeout(() => {
      fetch(`${API_BASE_URL}/api/subject-options?query=${subjectQuery}`)
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          setSubjectOptions(data.subjects.map((d) => d.subject));
        })
        .catch((err) => console.error("Error fetching:", err));
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [subjectQuery]);

  return (
    <div>
      {loader && (
        <div className="loader">
          <div className="loader-spinner"></div>
        </div>
      )}
      <SideBar />
      <div className="main-content">
        <Header />

        <div id="form-content">
          <div id="form-header" style={{ textTransform: "uppercase" }}>
            <p>Data Range Report</p>
          </div>
          <hr />
          <form id="form">
            <div id="form-input">
              <label>
                Start Date<span className="required">*</span>
              </label>
              <input
                type="date"
                name="startDate"
                placeholder="Select Start Date"
                value={query.startDate}
                onChange={(e) => {
                  setQuery({ ...query, startDate: e.target.value });
                  setReport(false);
                  setButtonClicked(false);
                }}
                required
              />
            </div>
            <div id="form-input">
              <label>
                End Date<span className="required">*</span>
              </label>
              <input
                type="date"
                name="endDate"
                placeholder="Select End Date"
                value={query.endDate}
                onChange={(e) => {
                  setQuery({ ...query, endDate: e.target.value });
                  setReport(false);
                  setButtonClicked(false);
                }}
                required
              />
            </div>
            <div id="form-input">
              <label>
                Letter Type<span className="required">*</span>
              </label>
              <select
                name="letterType"
                value={query.letterType}
                onChange={(e) => {
                  setQuery({ ...query, letterType: e.target.value });
                  setReport(false);
                  setButtonClicked(false);
                }}
                required
              >
                <option value="" disabled>
                  Select Letter Type
                </option>
                <option value="Receive">Received</option>
                <option value="Dispatch">Dispatch</option>
              </select>
            </div>
            <div id="form-input">
              <label htmlFor="subject">
                Subject<span className="required">*</span>
              </label>
              <input
                type="text"
                name="subject"
                id="subject"
                placeholder="Select Subject"
                required
                value={subjectQuery}
                onChange={(e) => {
                  setSubjectQuery(e.target.value);
                  setQuery({ ...query, subject: e.target.value });
                  setReport(false);
                  setButtonClicked(false);
                }}
                autoComplete="off"
                list="subject-options"
              />
              <datalist id="subject-options">
                {subjectOptions.map((option, index) => (
                  <option key={index} value={option} />
                ))}
              </datalist>
            </div>
          </form>
          <div className="button">
            <button
              type="button"
              className="btn"
              id="search"
              onClick={() => {
                setReport(true);
                setLoader(true);
                setButtonClicked(true);
              }}
              disabled={buttonClicked}
            >
              SEARCH
            </button>
          </div>
        </div>
        {report && <DateReportTable query={query} setLoader={setLoader} />}
      </div>
    </div>
  );
}
export default DateRangeReport;
